import React, { useCallback, useRef, useState } from 'react'
import Webcam from 'react-webcam'
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  Typography
} from '@material-ui/core'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import { PhotoCamera } from '@material-ui/icons'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})

const PhotoModal = ({ open, onClose, loadFile }) => {
  const webcamRef = useRef(null)
  const [imgSrc, setImgSrc] = useState(null)

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImgSrc(imageSrc)
  }, [webcamRef, setImgSrc])

  const handleSave = () => {
    fetch(imgSrc)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'ClientPhoto', { type: 'image/png' })
        loadFile(file)
        onClose()
      })
  }
  return (
    <Dialog open={open} fullScreen TransitionComponent={Transition}>
      <AppBar style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">Фотография</Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Grid
          container
          spacing={2}
          justify={'center'}
          alignItems={'center'}
          style={{ marginTop: 80 }}
        >
          <Grid item style={{ position: 'relative' }}>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/png"
            />
            <Button
              color={'primary'}
              variant={'contained'}
              onClick={capture}
              style={{ position: 'absolute', bottom: 28, left: '45%' }}
            >
              <PhotoCamera />
            </Button>
          </Grid>
          {imgSrc && (
            <Grid item style={{ position: 'relative' }}>
              <img src={imgSrc} alt="" />{' '}
              <Button
                color={'primary'}
                variant={'contained'}
                onClick={handleSave}
                style={{
                  position: 'absolute',
                  bottom: 28,
                  left: '36%',
                  backgroundColor: 'green'
                }}
              >
                Сохранить фото
              </Button>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
export default PhotoModal
